import { MuiButton } from '@/components/button/MuiButton';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { Box, Button, Typography } from '@mui/material';
import { useLogic } from './logic';

type Props = {
  setTmpToken: (value: string) => void;
};

export function InputSecurityCodeForm({ setTmpToken }: Props) {
  const { control, onClickSubmit } = useLogic({ setTmpToken });
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        width: '400px',
        maxWidth: '90%',
        my: 6,
        mx: 'auto',
      }}
    >
      <Typography variant="JP/Body/m/Regular/Normal">
        電話番号またはメールアドレスに送られた6桁のセキュリティコードを入力してください。
      </Typography>
      <Box
        component="form"
        onSubmit={onClickSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
      >
        <MuiTextField
          key={control.register('key_code').name}
          name={control.register('key_code').name}
          control={control}
          label="セキュリティコード"
          required
          fullWidth
        />
        <MuiButton type="submit">送信</MuiButton>
        <Button
          type="button"
          variant="text"
          href="https://news.ewellibow.jp/%E3%82%BB%E3%82%AD%E3%83%A5%E3%83%AA%E3%83%86%E3%82%A3%E3%82%B3%E3%83%BC%E3%83%89%E3%81%8C%E5%B1%8A%E3%81%8B%E3%81%AA%E3%81%8B%E3%81%A3%E3%81%9F%E5%A0%B4%E5%90%88/"
          target="_blank"
        >
          セキュリティコードが届かなかった場合
        </Button>
      </Box>
    </Box>
  );
}
